import { useEnv } from '~/env'
import type { EnvType } from '~/env'

export function useNewPriceRange() {
  const env = useEnv()
  return isNewPriceRange(env)
}

function isNewPriceRange(env?: EnvType) {
  return (
    env !== undefined &&
    env !== null &&
    'FEATURE_NEW_PRICE_RANGE' in env &&
    env.FEATURE_NEW_PRICE_RANGE === '1'
  )
}

if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('isNewPriceRange', () => {
    test('FEATURE_NEW_SEARCH_BOX is not defined', () => {
      expect(isNewPriceRange({} as EnvType)).toBe(false)
    })

    test('FEATURE_NEW_SEARCH_BOX is 1', () => {
      expect(isNewPriceRange({ FEATURE_NEW_PRICE_RANGE: '1' } as EnvType)).toBe(true)
    })
  })
}
